import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { BrandCustom } from "../../../models/brand.custom";
import { Button } from "../../Form";

interface Props {
  currentBrand?: BrandCustom;
}

const styles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  titleGray: {
    color: "#93A9BD",
  },
  titleSelected: {
    color: (props: Props) => props?.currentBrand?.primaryColor || "#38CFC4",
  },
  itemSelected: {
    backgroundColor: (props: Props) => props?.currentBrand?.primaryColor || "#38CFC4",
    color: "#FFFFFF",
  },
  customBadge: {
    backgroundColor: (props: Props) => props?.currentBrand?.primaryColor || "#38CFC4",
    marginTop: "3px",
    padding: 0,
    height: "16px",
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 700,
    transform: "scale(1) translate(0%, 50%)",
  },
  companyProfileName: {
    padding: "0 10px",
  },
  swipeArea: {
    height: "0px !important",
  },
  appBar: {
    backgroundColor: "#EDF5FB",
  },
  toolbar: {
    padding: "0 32px",
    backgroundColor: (props: Props) => props?.currentBrand?.headerBackgroundColor || "#EDF5FB",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  containerLogo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  link: {
    marginBottom: "5px",
  },
  image: {
    height: "35px",
    marginBottom: (props: Props) => (props?.currentBrand?.enableCustomLogo ? undefined : "8px"),
  },
  buttonSelected: {
    backgroundColor: (props: Props) =>
      props?.currentBrand?.primaryColor ? props?.currentBrand?.primaryColor : "#03569E",
  },
  containerNavBarLink: {
    display: "flex",
    alignItems: "center",
  },
  containerActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  title: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "24px",
    transition: "all .2s ease-in-out",
  },
  containerTitle: {
    cursor: "pointer",
    "&:hover span": {
      color: (props: Props) =>
        props?.currentBrand?.primaryColor
          ? `${props?.currentBrand?.primaryColor} !important`
          : "#38CFC4 !important",
    },
    marginLeft: "32px",
  },
  containerTitleSelected: {
    padding: "3px 0px",
    boxShadow: (props: Props) =>
      props?.currentBrand?.primaryColor
        ? `0px 3px 0px ${props?.currentBrand?.primaryColor}`
        : " 0px 3px 0px #38CFC4",
    cursor: "pointer",
    marginLeft: "32px",
  },
  itemAction: {
    marginRight: "16px",
  },
}));

export const LogoutInfoTitle = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
}));

export const LogoutInfoText = styled("p")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
}));

export const LogoutInfoWrapper = styled("div")(() => ({
  display: "flex",
  paddingBottom: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
}));

export const LogoutInfoTextContainer = styled("div")(() => ({
  display: "flex",
  width: "312px",
  padding: "4px 16px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
}));

export const LogoutButton = styled(Button)(() => ({
  marginLeft: "8px",
}));

export const WarningBadge = styled("div")(() => ({
  width: "6px",
  height: "6px",
  borderRadius: "100px",
  background: "#F04438",
  marginBottom: "10px",
}));

export default styles;
